import LocationAndPoints from '../../../../../pages/vip/features/location-and-points/location-and-points.desktop';

export default LocationAndPoints;
